// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Ioao","buttons":"PendingPaymentAlert_buttons__EdNmZ"};